import Backbone from 'backbone';
import $ from '@rm/jquery';
import _ from '@rm/underscore';
import { Utils } from '../common/utils';
import Scale from '../common/scale';
import templates from '../../templates/viewer/picture-preview.tpl';

/**
 * Picture preview
 *
 * @param {jQuery} $container — контейнер окна
 * @param {jQuery} $el — контейнер исходного изображения
 * @param {string} overlayColor — цвет подложки
 * @param {string} picture — объект picture из модели виджета
 * @param {number} originalW — ширина оригинала изображения
 * @param {number} width — ширина виджета изображения
 */

const TRANSITION_TIME = 300;
const PicturePreview = Backbone.View.extend({
  initialize: function(params) {
    _.bindAll(this);
    _.extend(this, params);
  },

  render: function() {
    this.removing = false;

    $('body').addClass('picture-preview-loading');

    this.originalRect = this.$el[0].getBoundingClientRect();
    this.orientation = this.getOrientation();
    this.originalStyle = this.getOriginalStyle();

    var previewTemplate = templates['template-picture-preview-box'];
    this.$preview = $(
      previewTemplate({
        overlayColor: this.overlayColor,
        previewSrc: this.getPreviewSrc(),
        originalStyle: this.originalStyle,
      })
    );

    this.$container.append(this.$preview);
    $(window).on('scroll', this.onScroll);
    $('body').on('keypress keyup keydown', this.onKeyPress);

    // Запускаем анимацию
    setTimeout(this.setVisible, 100);

    return this.$preview;
  },

  imagePreload: function() {
    if (this.removing) return;

    var originalSrc =
      this.picture.unscaledUrl || this.picture.final3xUrl || this.picture.final2xUrl || this.picture.finalUrl;
    var previewSrc = this.getPreviewSrc();

    // Не грузим оригинал, если исходник уже и есть оригинал
    if (previewSrc === originalSrc) {
      $('body').removeClass('picture-preview-loading');
      return;
    }

    this.img = new Image();
    this.img.onload = function() {
      // Возможно превью закрыли до момента загрузки хайреса
      $('body').removeClass('picture-preview-loading');
      if (!this.$preview) return;

      setTimeout(
        function() {
          if (this.removing) return;

          var img = this.$preview.find('.picture-preview-box .picture-preview-box-image');

          img.attr('src', this.img.src).removeAttr('srcset');
        }.bind(this),
        100
      );
    }.bind(this);

    this.img.src = originalSrc;
  },

  remove: function(cb) {
    this.removing = true;

    $('body').removeClass('picture-preview-loading');
    $('body').off('keypress keyup keydown', this.onKeyPress);
    $(window).off('scroll', this.onScroll);

    // Аборт прелоада картинки
    if (this.img) {
      this.img.src = '';
      delete this.img;
    }

    if (this.$preview) {
      var $el = this.$preview.find('.picture-preview-box');
      $el.removeClass('visible loaded').removeClass(this.orientation);

      Utils.waitForTransitionEnd(
        $el.find('.picture-preview-box-overlay'),
        TRANSITION_TIME,
        'opacity',
        function() {
          this.$preview && this.$preview.remove();
          delete this.$preview;
        }.bind(this)
      );

      cb && cb();
    }
  },

  changeColor: function(newColor) {
    this.$preview && this.$preview.find('.picture-preview-box-overlay').css('background-color', newColor);
  },

  onScroll: function() {
    this.remove();
  },

  /**
   * Запускает анимацию появления и подгрузку оригинала
   * только когда загрузится и отобразится превью
   */
  setVisible: function() {
    if (this.removing) return;

    var previewImg = this.$preview.find('.picture-preview-box img')[0];
    var onLoad = function() {
      previewImg.removeEventListener('load', onLoad);

      this.$preview
        .find('.picture-preview-box')
        .addClass('visible')
        .addClass(this.orientation);

      Utils.waitForTransitionEnd(
        this.$preview.find('.picture-preview-box .picture-preview-box-overlay'),
        TRANSITION_TIME,
        'opacity',
        this.imagePreload
      );
    }.bind(this);

    setTimeout(function() {
      if (previewImg.complete) {
        onLoad();
      } else {
        previewImg.addEventListener('load', onLoad);
      }
    }, 100);
  },

  /**
   * Достает src, который в данный момент отображается в виджете
   */
  getPreviewSrc: function() {
    var img = this.$el.find('img')[0];

    // currentSrc будет в случае наличия srcset
    return (
      (img && (img.currentSrc || img.src)) ||
      this.picture.final3xUrl ||
      this.picture.final2xUrl ||
      this.picture.finalUrl
    );
  },

  /**
   * Собирает объект стилей виджета
   *
   * Нужен для того, чтобы транзишн начинался в рамке виджета и туда же возвращался
   */
  getOriginalStyle: function() {
    if (!this.originalRect) return {};

    // Если у страницы включен Scale Layout с использованием Zoom,
    // то нужно сделать поправку в позиции на величину зума
    var isZoom = Scale.isAllowed() && Scale.isZoom();
    var scaleRatio = Scale.getRatio();

    var result = {
      top: Number(this.originalRect.top + this.originalRect.height * 0.5) * (isZoom ? scaleRatio : 1) + 'px',
      left: Number(this.originalRect.left + this.originalRect.width * 0.5) * (isZoom ? scaleRatio : 1) + 'px',
    };

    if (this.orientation === 'portrait') {
      result.height = this.originalRect.height * (isZoom ? scaleRatio : 1) + 'px';
    } else if (this.orientation === 'landscape') {
      result.width = this.originalRect.width * (isZoom ? scaleRatio : 1) + 'px';
    }

    return result;
  },

  /**
   * Получает тип ориентации
   *
   * Пытается вписать картинку в экран и определяет ориентацию в зависимости от того,
   * входит картинка в экран по ширине или высоте
   */
  getOrientation: function() {
    var ratio = this.originalRect.height / this.originalRect.width,
      windowWidth = $(window).width(),
      windowHeight = $(window).height();

    var newWidth = windowHeight / ratio;
    return newWidth < windowWidth ? 'portrait' : 'landscape';
  },

  bindClick: function() {
    if (this.$preview) {
      this.$preview.on(
        'click',
        function() {
          this.remove();
        }.bind(this)
      );
    }
  },

  onKeyPress: function(e) {
    if (e.keyCode === 27) {
      this.remove();
    }
  },
});

export default PicturePreview;
